import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Lock } from 'lucide-react';
export function Offer() {
  return <section id="offer-section" className="bg-brand-dark text-brand-cream py-24 px-6 relative overflow-hidden" data-id="element-139">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-gold to-transparent opacity-50" data-id="element-140"></div>
      <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-brand-gold rounded-full mix-blend-screen filter blur-[128px] opacity-20 pointer-events-none" data-id="element-141"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-142">
        <FadeIn data-id="element-143">
          <h2 className="text-3xl md:text-5xl font-bold mb-8 text-brand-cream" data-id="element-144">
            Es momento de dejar de elegir entre tu bienestar y tu cuenta
            bancaria.
          </h2>
          <p className="text-xl font-light text-brand-cream/80 mb-12 max-w-2xl mx-auto" data-id="element-145">
            Consigue el sistema completo por una fracción de lo que te costaría
            una sesión de coaching o una consulta médica por agotamiento.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-146">
          <div className="bg-brand-green/40 border border-brand-gold/30 p-8 md:p-12 rounded-sm max-w-2xl mx-auto shadow-2xl backdrop-blur-sm" data-id="element-147">
            <h3 className="font-serif text-2xl mb-2 text-brand-gold" data-id="element-148">
              Riqueza Integral:
            </h3>
            <p className="text-xl mb-8 text-brand-cream/90" data-id="element-149">
              El Método de los 4 Cuerpos
            </p>

            <div className="flex flex-col items-center mb-10" data-id="element-150">
              <div className="flex items-baseline gap-3 mb-2" data-id="element-151">
                <span className="text-2xl text-brand-cream/40 line-through" data-id="element-152">
                  $27
                </span>
                <span className="text-sm uppercase tracking-wider text-red-400 font-bold" data-id="element-153">
                  Oferta limitada
                </span>
              </div>
              <div className="flex items-baseline gap-2" data-id="element-154">
                <span className="text-2xl text-brand-cream/60" data-id="element-155">por solo</span>
                <span className="text-6xl font-bold text-brand-gold" data-id="element-156">
                  $9.99
                </span>
              </div>
            </div>

            <Button fullWidth className="text-lg py-5 mb-6" href="https://tuvidaenlibertad.com/cart/48207345287403:1" data-id="element-157">
              QUIERO MI COPIA AHORA
            </Button>

            <div className="flex items-center justify-center gap-2 text-sm text-brand-cream/60" data-id="element-158">
              <Lock className="w-4 h-4 text-brand-gold" data-id="element-159" />
              <span data-id="element-160">Compra segura. Acceso instantáneo en formato PDF.</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}